import { updateSharedState } from '@/utils/storage/sharedState';

// Read by the onboarding miniapp; set when a free-quota run is submitted, so an
// absent key means the user never started one here.
export const markFreeQuotaSpent = () =>
  updateSharedState({ freeQuotaSpent: true });
